import { FormControl, FormHelperText, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { GetActiveContractsResponseDto } from '../../core/api/dtos';
import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { StyledSelect } from '../../core/styles';
import { ContractTerminationStore } from '../contract-termination-store';
import { StyledBlackInputLabel, StyledBlackLabel } from '../styles';

export interface CancellationDateSelectProps {
    contract: GetActiveContractsResponseDto;
}

export const CancellationDateSelect = observer(
    (props: CancellationDateSelectProps) => {
        const { formatDate, translate } = injectTSDI(I18n);
        const contractTerminationStore = injectTSDI(ContractTerminationStore);
        const cancelContractForm =
            contractTerminationStore.getCancelContractForm(
                props.contract.contractId
            );
        if (!cancelContractForm) {
            return <></>;
        }
        const { cancellationDate } = cancelContractForm.wrappedField;

        return (
            <FormControl
                fullWidth
                required
                variant="outlined"
                error={Boolean(cancellationDate.error)}
            >
                <StyledBlackInputLabel
                    id="terminate-contract-by"
                    htmlFor="terminate-contract-by-input"
                >
                    {translate('public.content.terminate.contract.by')}
                </StyledBlackInputLabel>
                <StyledSelect
                    labelId="terminate-contract-by"
                    inputProps={{ id: 'terminate-contract-by-input' }}
                    id="contract-termination-date"
                    value={cancellationDate.value?.toDate().valueOf() ?? ''}
                    label={
                        <StyledBlackLabel>
                            {translate('public.content.terminate.contract.by')}
                        </StyledBlackLabel>
                    }
                    onChange={(event) =>
                        contractTerminationStore.updateDateIfValid(
                            event,
                            cancellationDate
                        )
                    }
                >
                    {props.contract.cancellationDates?.map((date) => (
                        <MenuItem
                            key={date.valueOf().toString()}
                            value={date.valueOf().toString()}
                        >
                            {formatDate(date)}
                        </MenuItem>
                    ))}
                </StyledSelect>
                <FormHelperText>
                    {cancellationDate.error
                        ? translate(cancellationDate.error)
                        : undefined}
                </FormHelperText>
            </FormControl>
        );
    }
);
